import { render, staticRenderFns } from "./Saves.vue?vue&type=template&id=36b8c5f1&scoped=true&"
import script from "./Saves.vue?vue&type=script&lang=js&"
export * from "./Saves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b8c5f1",
  null
  
)

export default component.exports